import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { string, bool } from 'prop-types';

export const ProjectShoppingHeader = ({ content, isAssortmentHeader, isEntryPoint, title }) => {
  const displayTitle = !isAssortmentHeader || isEntryPoint ? `${title}?` : title;

  return (
    <div className="sui-mb-4">
      <Typography variant={isEntryPoint ? 'h3' : 'h2'}>{displayTitle}</Typography>
      <Typography variant="body-base">{content}</Typography>
    </div>
  );
};

ProjectShoppingHeader.propTypes = {
  content: string,
  isAssortmentHeader: bool,
  isEntryPoint: bool,
  title: string
};
ProjectShoppingHeader.defaultProps = {
  content: '',
  isAssortmentHeader: false,
  isEntryPoint: false,
  title: ''
};

export default ProjectShoppingHeader;